// extracted by mini-css-extract-plugin
export default {"root":"BlogListing_root__2qfC1","title":"BlogListing_title__1y8MS h3","postDate":"BlogListing_postDate__0gJrD","square":"BlogListing_square__dK3on"};